module.exports = __webpack_public_path__ + "img/CM.a0e9c21a.png";